import { PresentationAct, getEngineContext } from "onearm";

export class PaylinePaysAct extends PresentationAct {
    constructor({ result, reelsScene, hud, gameLogic, data, paylinesContainer }) {
        super({ skipStep: true });
        this.result = result;
        this.reels = reelsScene;
        this.hud = hud;
        this.gameLogic = gameLogic;
        this.data = data;
        this.paylinesContainer = paylinesContainer;
        this.anim = getEngineContext().services.get("animations");
    }

    get isTurboSpin() {
        return this.data?.spinType === "turbo";
    }

    action() {
        const { pays } = this.result;
        if (!pays || pays.length === 0) return this.timeline;

        const symbolWin = this.anim.get("symbolWin");
        const paylineAnimation = this.anim.get("paylineAnimation");

        const paySymbols = pays.map(pay =>
            pay.positions
                .map(({ col, row }) => this.reels.getSymbolByPosition({ row, column: col }))
                .filter(Boolean),
        );

        this.timeline.add(() => {
            this.reels.showShadow();
            this.hud.showWin();
            this.hud.setLineWin(pays[0].win);
        });
        this.timeline.add(this.hud.fadeInLineWin());

        const lineDuration = this.isTurboSpin ? 0.5 : 1.2;

        for (let i = 0; i < pays.length; i++) {
            const pay = pays[i];
            const symbols = paySymbols[i];

            this.timeline.add(() => {
                this.reels.liftSymbolsForAnimation(symbols);
                this.hud.addWin(pay.win);
                this.hud.setLineWin(pay.win);
            });

            const symbolAnims = symbols.map(symbol => symbolWin(symbol));
            const lineFlash = paylineAnimation(this.paylinesContainer, pay.lineIndex, {
                duration: lineDuration,
            });
            this.timeline.add([...symbolAnims, lineFlash], this.timeline.duration());

            this.timeline.add(() => this.reels.restoreSymbols(symbols));
        }

        this.timeline.add(this.hud.fadeOutLineWin());

        this.timeline.add(() => {
            this.reels.endPaysAnimation();
            this.hud.animBalance(this.gameLogic.balance);
        });

        return this.timeline;
    }

    skip() {
        this.paylinesContainer?.hideAll();
        this.reels.endPaysAnimation();
        this.hud.hideLineWin();
        this.hud.showWin();
        this.hud.setWin(this.result.win);
        this.hud.setBalance(this.gameLogic.balance);
    }
}
